import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import '../../../static/less/extras/extras.less';
import FreeModeCart from '../free-mode/FreeModeCart';
import '../../../static/less/callcenter/callcenter.less';
import { MULTIPLE_ROOMS } from '../../../constants';
import ExtraList from './ExtraList';
import withNavigate from '../../../withNavigate'; // Importa el HOC

class ExtrasList extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
    };

    this.renderExtrasList = this.renderExtrasList.bind(this);
    this.isEmptyCart = this.isEmptyCart.bind(this);
    this.goToConfirmation = this.goToConfirmation.bind(this);
  }

  renderExtrasList(key, extras) {
    return (
            <div className={'FreeMode row'} key={key}>
              <div className={'col-xs-12 col-md-9'}>
                <ExtraList
                        key={key}
                        showCustomAndList={true}
                        extras={extras}
                        roomId={key}
                        hasToggle={false}
                        onClickContinue={this.goToConfirmation}
                />
              </div>
              <div className="col-xs-12 col-md-3">
                <FreeModeCart/>
              </div>
            </div>
    );
  }

  isEmptyCart() {
    return this.props.cart.cartHotel.isEmpty;
  }

  goToConfirmation() {
    if (!this.isEmptyCart()) {
      this.props.navigate('/confirmation/');
    }
  }

  render() {
    const {
      extras,
    } = this.props;
    const { FIRST } = MULTIPLE_ROOMS;
    const extrasExtras = extras && extras[FIRST] ? extras : null;
    if (!extrasExtras) {
      return null;
    }
    return (
            // eslint-disable-next-line react/no-string-refs
            <main ref="ExtrasList FreeMode">
              {Object.entries(extrasExtras).map(([key, extrasArray]) =>
                (extrasArray && this.renderExtrasList(key, extrasArray)))}
            </main>);
  }
}

ExtrasList.propTypes = {
  navigate: PropTypes.func.isRequired, // Prop para `navigate`
};

ExtrasList.contextTypes = {
  t: PropTypes.func.isRequired,
  onClickContinue: PropTypes.func,
  showCustomAndList: PropTypes.bool,
};

// Conectar el componente con Redux
const mapStateToProps = (state) => ({
  extras: state.extras.extrasByRoomSelected,
  hotel: state.booking.hotel,
  cart: state.cart,
});

const ConnectedExtrasList = connect(mapStateToProps)(ExtrasList);

// Exportar el componente envuelto con el HOC
export default withNavigate(ConnectedExtrasList);
